import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import '@refinitiv-ui/efx-grid';
import '@refinitiv-ui/elements/layout';
import '@refinitiv-ui/elements/sidebar-layout';
import '@refinitiv-ui/elements/panel';
import '@refinitiv-ui/elements/header';
import '@refinitiv-ui/elements/button';
import '@refinitiv-ui/elements/button-bar';
import '@refinitiv-ui/elements/tab';
import '@refinitiv-ui/elements/tab-bar';
import '@refinitiv-ui/elements/tree';
import '@refinitiv-ui/elements/item';
import '@refinitiv-ui/elements/icon';
import '@refinitiv-ui/elements/flag';
import '@refinitiv-ui/elements/text-field';
import '@refinitiv-ui/elements/search-field';
import '@refinitiv-ui/elements/accordion';
import '@refinitiv-ui/elements/collapse';
import '@refinitiv-ui/elements/pill';
import '@refinitiv-ui/elements/loader';
import '@refinitiv-ui/elements/overlay';
import '@refinitiv-ui/elements/progress-bar';
import '@refinitiv-ui/elements/dialog';
import '@refinitiv-ui/elements/checkbox';
import '@refinitiv-ui/elements/radio-button';
import '@refinitiv-ui/elements/tooltip';
import '@refinitiv-ui/elements/notification';
import '@refinitiv-ui/elements/pagination';
import '@refinitiv-ui/elements/select';

import '@refinitiv-ui/halo-theme/light/imports/native-elements';
import '@refinitiv-ui/efx-grid/themes/halo/light';
import '@refinitiv-ui/elements/layout/themes/halo/light';
import '@refinitiv-ui/elements/sidebar-layout/themes/halo/light';
import '@refinitiv-ui/elements/panel/themes/halo/light';
import '@refinitiv-ui/elements/header/themes/halo/light';
import '@refinitiv-ui/elements/button/themes/halo/light';
import '@refinitiv-ui/elements/button-bar/themes/halo/light';
import '@refinitiv-ui/elements/tab/themes/halo/light';
import '@refinitiv-ui/elements/tab-bar/themes/halo/light';
import '@refinitiv-ui/elements/tree/themes/halo/light';
import '@refinitiv-ui/elements/item/themes/halo/light';
import '@refinitiv-ui/elements/icon/themes/halo/light';
import '@refinitiv-ui/elements/flag/themes/halo/light';
import '@refinitiv-ui/elements/text-field/themes/halo/light';
import '@refinitiv-ui/elements/search-field/themes/halo/light';
import '@refinitiv-ui/elements/accordion/themes/halo/light';
import '@refinitiv-ui/elements/collapse/themes/halo/light';
import '@refinitiv-ui/elements/pill/themes/halo/light';
import '@refinitiv-ui/elements/loader/themes/halo/light';
import '@refinitiv-ui/elements/overlay/themes/halo/light';
import '@refinitiv-ui/elements/progress-bar/themes/halo/light';
import '@refinitiv-ui/elements/dialog/themes/halo/light';
import '@refinitiv-ui/elements/checkbox/themes/halo/light';
import '@refinitiv-ui/elements/radio-button/themes/halo/light';
import '@refinitiv-ui/elements/tooltip/themes/halo/light';
import '@refinitiv-ui/elements/notification/themes/halo/light';
import '@refinitiv-ui/elements/pagination/themes/halo/light';
import '@refinitiv-ui/elements/select/themes/halo/light';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);


